import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {captureLinkClick, capturePageView} from '../analytics';

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    capturePageView(location);
  }, [location]);

  useEffect(() => {
    function handleClick(event) {
      const link = event.target.closest && event.target.closest('a');

      if (link) {
        captureLinkClick(link);
      }
    }

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return null;
}
